import request from '@/utils/request'
import newRequest from '@/utils/newOpenRequest'
import { Http } from '../model/Http'
const httpModel = new Http()

export function requestAjax(data, url, method) {
    return request({
        url: url,
        method: method,
        data
    })
}

export function login(data) {
    return request({
      url: '/index/index/login',
      method: 'post',
      data
    })
}

export function getInfo(token) {
    return request({
      url: '/index/index/info',
      method: 'get',
      params: { token }
    })
}

export function logout() {
    return request({
      url: '/index/index/logout',
      method: 'post'
    })
}
/**
 * 用户余额记录
 */
export function getUserBalanceList(data) {
  return request({
    url: '/index/user/userBalanceList',
    method: 'post',
    data
  })
}

/**
 * 用户基本信息
 */
export function getUserInfo(data) {
  return request({
    url: '/index/user/userInfo',
    method: 'post',
    data
  })
}

/**
 * 用户注册短信发送
 */
export function registerSms(data) {
  return request({
    url: '/index/user/registerSms',
    method: 'post',
    data
  })
}

/**
 * 用户注册
 */
export function register(data) {
  return request({
    url: '/index/user/register',
    method: 'post',
    data
  })
}

/**
 * 用户修改密码短信发送
 */
export function forgetPwdSms(data) {
  return request({
    url: '/index/user/forgetPwdSms',
    method: 'post',
    data
  })
}

/**
 * 用户修改密码
 */
export function forgetPwd(data) {
  return request({
    url: '/index/user/forgetPwd',
    method: 'post',
    data
  })
}

/**
 * 用户申请开发者短信
 */
export function applyDeveloperSms(data) {
  return request({
    url: '/index/user/applyDeveloperSms',
    method: 'post',
    data
  })
}

/**
 * 用户申请开发者
 */
export function applyDeveloper(data) {
  return request({
    url: '/index/user/applyDeveloper',
    method: 'post',
    data
  })
}

/**
 * 用户个人设置
 */
export function setting(data) {
  return request({
    url: '/index/user/setting',
    method: 'post',
    data
  })
}

/**
 * 获取客服信息
 */
export function getServerConfig(data) {
  return request({
    url: '/index/index/getServerConfig',
    method: 'post',
    data
  })
}

/**
 * 余额设置（用于短信提醒）
 */
export function setBalanceTip(data) {
  return request({
    url: '/index/account/balanceTip',
    method: 'post',
    data
  })
}

// 账户中心 - 提现记录
export function getRecordList(data) {
  return newRequest({
    url: '/open/open/user-withdraw/search',
    method: 'post',
    data,
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js